// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-page-js": () => import("/opt/buildhome/repo/src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */),
  "component---src-templates-landing-js": () => import("/opt/buildhome/repo/src/templates/landing.js" /* webpackChunkName: "component---src-templates-landing-js" */),
  "component---src-templates-blog-js": () => import("/opt/buildhome/repo/src/templates/blog.js" /* webpackChunkName: "component---src-templates-blog-js" */),
  "component---src-templates-guides-js": () => import("/opt/buildhome/repo/src/templates/guides.js" /* webpackChunkName: "component---src-templates-guides-js" */),
  "component---src-templates-guide-js": () => import("/opt/buildhome/repo/src/templates/guide.js" /* webpackChunkName: "component---src-templates-guide-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/buildhome/repo/.cache/data.json")

